export type TreatmentCaseSummaryResponse = {
  createdAt: string
  hospitalOriginId: number
  hospitalOriginName: string
  hospitalThumbnailUrl: string
  thumbnail: {
    afterImageUrl: string | null
    beforeImageUrl: string | null
  }
  title: string
  treatmentCaseId: number
  treatmentSubjectId: number
  treatmentSubjectName: string
}

export type TreatmentCaseListResponse = {
  offset: number
  limit: number
  total: number
  masking: boolean
  contents: TreatmentCaseSummaryResponse[]
}

export type TreatmentCaseSubject = {
  treatmentSubjectId: number,
  treatmentSubjectName: string,
  depth: number
}

export type TreatmentCaseTopic = TreatmentCaseSubject & {
  caseCount: number | null
}

export type TreatmentCaseFilterResponse = {
  treatmentCategoryId: number,
  treatmentCategoryName: string,
  treatmentSubjects: TreatmentCaseSubject[]
}[]


export const TREATMENT_CASE_SORT = {
  VIEW_COUNT_DESC: "VIEW_COUNT_DESC",
  CREATED_AT_DESC: "CREATED_AT_DESC",
} as const

export type TreatmentCaseSort = (typeof TREATMENT_CASE_SORT)[keyof typeof TREATMENT_CASE_SORT]

export const TREATMENT_CASE_SORT_LABEL: Record<TreatmentCaseSort, string> = {
  [TREATMENT_CASE_SORT.VIEW_COUNT_DESC]: "인기순",
  [TREATMENT_CASE_SORT.CREATED_AT_DESC]: "최신순",
}

export const TREATMENT_CASE_SORT_OPTIONS: readonly TreatmentCaseSort[] = [
  TREATMENT_CASE_SORT.VIEW_COUNT_DESC,
  TREATMENT_CASE_SORT.CREATED_AT_DESC,
]

export type TreatmentCaseDetailResponse = {
  treatmentSubjectName: string
  title: string
  createdAt: string
  viewCount: number
  hospitalOriginId: number
  hospitalOriginName: string
  hospitalFullAddress: string
  hospitalThumbnailUrl: string
  content: string
  isHelpful: boolean
}
